export const levelName = 'Insel 12: Tamatiti';
export const ground = [
    [0,0,0,0,0,0,1,1,1,1,0,0,0,0,1,1,1,1,0,0],
    [0,0,0,0,0,1,1,1,1,1,0,1,1,1,1,2,2,1,1,0],
    [0,0,0,0,0,1,1,1,1,1,0,1,1,2,2,2,2,5,1,0],
    [0,0,0,0,0,0,0,0,0,0,0,1,1,2,2,1,1,1,1,0],
    [0,1,1,1,1,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0],
    [1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0],
    [1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,0,0],
    [1,1,1,1,1,1,1,1,1,1,1,1,0,0,1,1,1,1,0,0],
    [1,1,1,1,2,2,2,2,2,1,1,1,0,0,1,1,1,1,0,0],
    [1,1,4,1,2,2,2,2,2,1,1,0,0,0,1,1,1,0,0,0],
    [0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
];
export const objects = [
    [0,0,0,0,0,0,6,2,5,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,4,0,0,0,0,0,0,0,0,0,6,0,0,0,0],
    [0,0,0,0,0,0,4,0,0,0,0,0,0,0,3,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,3,0,0,6,4,5,0,0,0,0,0,0,0,0,0,0,0],
    [5,0,0,0,3,0,0,0,0,0,6,0,0,0,0,0,0,5,0,0],
    [4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3,0,0,0,0],
    [6,0,0,0,0,6,4,6,0,0,0,0,0,0,0,0,8,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
];

export const initalPushyPosition = [3,8];
